import React from 'react';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultQuotationRequestTemplate } from '@/utils/quotationRequestDefaultTemplate';
import { ACLAuthorizationRequest } from '@/api/bol';

export interface QuotationRequestFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; quotationRequestJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const QuotationRequestFormDialog: React.FC<QuotationRequestFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; quotationRequestJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    // Transform the generic jsonData back to the expected quotationRequestJson field
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      quotationRequestJson: data.quotationRequestJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations
    };
    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New QuotationRequest"
      jsonFieldName="quotationRequestJson"
      defaultJsonTemplate={defaultQuotationRequestTemplate()}
      jsonLabel="Enter a valid QuotationRequest JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the QuotationRequest schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};